import { parseQty, type PosRow } from '../formular';
import type { Leistung } from '../LeistungDaten';
import { gleicheEinheit, mengeText } from './LagerDaten';
import './lager.css';

// Marke unter einer Position, die aus einem Artikel mit „Bestand führen“ übernommen ist (Positionen.tsx, nur Billtoro):
// „Im Lager: 12 Stück“, gelb bei mehr Menge als Bestand (schreiben geht trotzdem), grau bei anderer Einheit (dann bucht
// der Server nicht ab). Sagt nie „wird abgebucht“: ob der Beleg bucht, entscheidet die Kette (Lieferschein oder
// Rechnung); was gebucht wurde, steht im Verlauf. × löst die Verbindung zum Artikel.
export function LagerMarke({ row, artikel, onLoesen }: { row: PosRow; artikel: Leistung[]; onLoesen(): void }) {
  const a = row.artikelId ? artikel.find((l) => l.id === row.artikelId) : undefined;
  if (!a?.lager || a.bestand == null) return null;
  const menge = parseQty(row.quantity);
  const einheitPasst = gleicheEinheit(row.unit, a.unit);
  const art = !einheitPasst ? 'aus' : menge !== undefined && menge > a.bestand ? 'wenig' : 'ok';
  const text =
    art === 'aus'
      ? `Einheit passt nicht zum Artikel (${a.unit}): wird nicht abgebucht.`
      : art === 'wenig'
        ? `Im Lager sind nur ${mengeText(a.bestand, a.unit)}.`
        : `Im Lager: ${mengeText(a.bestand, a.unit)}`;
  return (
    <span className={`lg-marke ${art}`}>
      <span>{text}</span>
      <button type="button" className="lg-marke-x" aria-label={`Verbindung zu ${a.name} im Lager lösen`} title="Verbindung zum Lager lösen" onClick={onLoesen}>
        ×
      </button>
    </span>
  );
}
